// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconFilledStar = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 25 24', fill: 'none', ...props },
    <path
      d="M17.671 22.844c.202.11.422.156.642.156.33 0 .65-.11.907-.348.431-.357.623-.934.477-1.484L18 15.023l4.574-4.525a1.43 1.43 0 00.339-1.502 1.431 1.431 0 00-1.21-.934l-5.527-.55-2.896-5.733A1.447 1.447 0 0011.998 1c-.54 0-1.036.302-1.283.788L7.819 7.52l-5.518.55a1.432 1.432 0 00-1.219.934 1.447 1.447 0 00.34 1.502l4.573 4.525-1.696 6.154a1.44 1.44 0 00.486 1.475 1.43 1.43 0 001.54.174l5.673-2.803 5.673 2.812z"
      fill="currentColor"
    />
  );
export default SvgIconFilledStar;
